import IconReceipt from 'src/assets/images/icons/analytic-receipt.svg';
import IconReceipt2 from 'src/assets/images/icons/receipt-orange.svg';
import IconDollar from 'src/assets/images/icons/dollar-square.svg';
import IconBox from 'src/assets/images/icons/box-remove.svg';
import Aproval from 'src/assets/images/icons/keymetric-icon.svg';
import IconUser from 'src/assets/images/icons/user-tick.svg';
import IconWarning from 'src/assets/images/icons/analytic-warning-error.svg';
import { createMetricsSelector, MetricOption } from '../../molecules/MetricsSelector';
import { CardId } from './types';

const AVAILABLE_METRICS: MetricOption<CardId>[] = [
  { id: CardId.NRCF_SHIPMENTS, label: 'NRCF Shipments', icon: IconReceipt2 },
  { id: CardId.UNIT_PRICE_DEVIATIONS, label: 'Unit Price Deviations', icon: IconDollar },
  { id: CardId.QUANTITY_DEVIATIONS, label: 'Quantity Deviations', icon: IconBox },
  { id: CardId.UNKNOWN_CHARGES, label: 'Unknown Charges', icon: Aproval },
  { id: CardId.APPROVALS, label: 'Approvals', icon: IconUser },
  { id: CardId.TOTAL_DEVIATION, label: 'Total Net Deviation Amount', icon: IconWarning },
  { id: CardId.TOTAL_FLAGGED, label: 'Total Flagged Items', icon: IconReceipt },
];

const DEFAULT_METRICS = [CardId.NRCF_SHIPMENTS, CardId.UNIT_PRICE_DEVIATIONS, CardId.QUANTITY_DEVIATIONS, CardId.UNKNOWN_CHARGES];

export const MetricsSelector = createMetricsSelector({
  metrics: AVAILABLE_METRICS,
  defaultMetrics: DEFAULT_METRICS,
});
